export const toFaDigits = (value: number | string): string => {
  const faDigits = '۰۱۲۳۴۵۶۷۸۹'
  return String(value).replace(/[0-9]/g, (d) => faDigits[Number(d)])
}

export const formatNumber = (value: number): string => {
  if (!isFinite(value)) return '۰'
  return new Intl.NumberFormat('en-US').format(Math.round(value))
}

export const toToman = (irrValue: number): number => Math.round(irrValue / 10)

export const formatToman = (irrValue: number): string => `${toFaDigits(formatNumber(toToman(irrValue)))} تومان`

export const formatRial = (irrValue: number): string => `${toFaDigits(formatNumber(irrValue))} ریال`

export const formatDateTimeFa = (date: string | Date): string => {
  try {
    return new Intl.DateTimeFormat('fa-IR', {
      year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit'
    }).format(new Date(date))
  } catch {
    return ''
  }
}

export const formatDateFa = (date: string | Date): string => {
  try {
    return new Intl.DateTimeFormat('fa-IR', { year: 'numeric', month: 'long', day: 'numeric' }).format(new Date(date))
  } catch {
    return ''
  }
}